import { render, staticRenderFns } from "./ExternalSyncLogListComponent.vue?vue&type=template&id=b2295ae6"
import script from "./ExternalSyncLogListComponent.vue?vue&type=script&lang=js"
export * from "./ExternalSyncLogListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports